module.exports = __webpack_public_path__ + "static/media/Explore white.5e0f0040.svg";